import React from 'react';
import { ListFilter, LayoutList } from 'lucide-react';

const ProgressViewToggle = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="flex items-center gap-2 mb-4 p-4 bg-white rounded-lg border border-gray-200">
      <span className="text-sm font-medium text-gray-700">View:</span>
      <div className="flex rounded-lg border border-gray-200 p-1">
        <button
          onClick={() => onViewModeChange('sections')}
          className={`flex items-center gap-2 px-3 py-1.5 rounded text-sm font-medium transition-colors
            ${viewMode === 'sections' 
              ? 'bg-gray-100 text-gray-900' 
              : 'text-gray-600 hover:text-gray-900'
            }`}
        >
          <ListFilter className="w-4 h-4" />
          By Section
        </button>
        <button
          onClick={() => onViewModeChange('all')}
          className={`flex items-center gap-2 px-3 py-1.5 rounded text-sm font-medium transition-colors
            ${viewMode === 'all' 
              ? 'bg-gray-100 text-gray-900' 
              : 'text-gray-600 hover:text-gray-900'
            }`}
        >
          <LayoutList className="w-4 h-4" />
          Show All
        </button>
      </div>
    </div>
  );
};

export default ProgressViewToggle;